export const alertsZh = {
  // 页面标题
  title: '预警',
  
  // 状态
  noAlerts: '暂无预警',
  abnormal: '异常',
};

export type AlertsTranslations = typeof alertsZh;

